<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <div>
                    <ErroResultados></ErroResultados>
                </div>
            </div>
            <template v-if="!erro">
                <ServidorForm :servidor="servidor" :lotacoesServidorForm="lotacoesServidorForm" :lotacoesOriginais="lotacoesOriginais"/>
            </template>
        </div>
    </div>
</template>

<script>
    import ServidorForm from "../../components/servidores/ServidoresForm.vue"
    import ServidorApi from "../../services/ServidorApi"
    
    import ErroResultados from "../../components/ErroResultados";
    import metaDados from "../../helpers/metaDados";

    export default {
        name: "ServidorEdit",
        metaInfo() {
            if (!this.servidor) {
                return {};
            }

            let title = this.servidor.nome;
            const description = this.servidor.nome;

            return {
                titleTemplate: "%s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    {
                        vmid: "twitter:description",
                        name: "twitter:description",
                        property: "twitter:description",
                        content: description,
                    },
                    {
                        vmid: "twitter:title",
                        name: "twitter:title",
                        property: "twitter:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                carregando: true,
                erro: false,
                servidor: null,
                lotacoesServidorForm: null,
                lotacoesOriginais: null,
            };
        },
        components: {
            ErroResultados,
            ServidorForm,
        },
        async created() {
            this.ServidorApi = new ServidorApi();
            this.carregarServidor();
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarServidor();
                }
            },
        },
        methods: {
            carregarServidor: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.ServidorApi.cancelTokens.getServidor) {
                    this.ServidorApi.cancelTokens.getServidor.cancel();
                    }
                    const [dadosServidor, todasUnidades] = await Promise.all([
                    this.ServidorApi.getServidor(this.$route.params.id),
                    this.ServidorApi.getUnidades(),
                    ]);

                    const lotacoesTratadas = (dadosServidor.lotacao_servidores || []).map(l => {
                    const unidadeObj = todasUnidades.find(u => u.id === l.id_unidade) || null;
                    const unidadeSuperiorObj = todasUnidades.find(u => u.id === l.id_unidade_superior) || null;

                    return {
                        id: l.id,
                        unidade: unidadeObj,
                        unidadeSuperior: unidadeSuperiorObj,
                        representante: !!l.representante,
                        dataInicio: l.data_inicio ? l.data_inicio.split("T")[0] : null,
                        dataFim: l.data_final ? l.data_final.split("T")[0] : null,
                    };
                    });

                    this.servidor = dadosServidor;
                    this.lotacoesServidorForm = lotacoesTratadas;
                    this.lotacoesOriginais = [...lotacoesTratadas];
                    this.carregando = false;
                } catch (err) {
                    if (this.ServidorApi.isCancel(err)) return;

                    console.error("❌ Erro ao carregar servidor:", err);
                    this.erro = true;
                    this.carregando = false;
                    this.servidor = null;
                }
            },

        },
    };
</script>

<style lang="scss" scoped>
</style>